<template>
  <div>
    <ColumnHeader title="Vedlegg" icon="mdi-paperclip">
      <v-btn
        class="ml-2"
        small
        color="primary"
        depressed
        @click="addAttachment"
      >
        Legg til
      </v-btn>
    </ColumnHeader>
    <FileDropzone
      ref="dropzone"
      v-model="attachments"
      :disableClick="disableClick"
      @change="attachmentsAdded"
    />
    <div v-show="count > attachments.length" class="text-center">
      <v-progress-circular indeterminate color="primary"></v-progress-circular>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import ColumnHeader from "@/components/shared/ColumnHeader.vue";
import FileDropzone from "@/components/shared/attachments/FileDropzone.vue";
import { fileObject } from "@/types/fileInterface";
export default Vue.extend({
  props: {
    value: {
      type: Array as () => Array<fileObject>,
      required: true,
    },
    disableClick: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      count: 0,
    };
  },
  methods: {
    addAttachment() {
      const dropzone: any = this.$refs.dropzone;
      dropzone.addAttachment();
    },
    async attachmentsAdded() {
      this.$emit("change");
    },
  },
  computed: {
    attachments: {
      get(): Array<fileObject> {
        return this.value;
      },
    },
  },
  components: {
    ColumnHeader,
    FileDropzone,
  },
});
</script>
